import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Checkbox,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SupportIcon from '@mui/icons-material/Support';
import PersonIcon from '@mui/icons-material/Person';
import ScannerIcon from '@mui/icons-material/Scanner';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import logo from '../assets/logo0.png';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

const Space = () => {
  const [adminExpanded, setAdminExpanded] = React.useState(true);
  const [legalExpanded, setLegalExpanded] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      bgcolor: '#f5f5f5',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Top Header */}
      <Box sx={{ 
        bgcolor: '#333', 
        color: 'white', 
        py: 1.5,
        borderBottom: '1px solid #444'
      }}>
        <Container maxWidth="xl" sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Box 
            component="img" 
            src={logo} 
            alt="Domain Factory" 
            sx={{ 
              height: 20,
              filter: 'brightness(0) invert(1)',
              cursor: 'pointer'
            }} 
            onClick={() => navigate('/dashboard')}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <Button 
              startIcon={<SupportIcon />}
              sx={{ color: 'white' }}
            >
              Support-Token anzeigen
            </Button>
            <Typography>+49 89 99 82 88-026</Typography>
            <Button 
              startIcon={<SupportIcon />}
              sx={{ color: 'white' }}
            >
              Support
            </Button>
            <Button 
              startIcon={<PersonIcon />}
              sx={{ color: 'white' }}
              onClick={handleProfileClick}
              aria-controls={open ? 'profile-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              K545569
            </Button>
            
            {/* Profile Menu */}
            <Menu
              id="profile-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'profile-button',
              }}
              sx={{
                '& .MuiPaper-root': {
                  mt: 1,
                  minWidth: 200,
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                }
              }}
            >
              <MenuItem onClick={handleClose} sx={{ py: 1.5 }}>
                <AccountCircleIcon sx={{ mr: 2 }} />
                My Profile
              </MenuItem>
              <MenuItem onClick={handleClose} sx={{ py: 1.5 }}>
                <SettingsApplicationsIcon sx={{ mr: 2 }} />
                Account Settings
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleClose} sx={{ py: 1.5, color: 'error.main' }}>
                <LogoutIcon sx={{ mr: 2 }} />
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxWidth="xl" sx={{ mt: 4, display: 'flex', gap: 4 }}>
        {/* Left Sidebar - Translated to English */}
        <Box sx={{ width: 280 }}>
          <Typography variant="subtitle2" sx={{ color: '#666', mb: 2 }}>
            CUSTOMER: K545569
          </Typography>

          <List component="nav" sx={{ bgcolor: 'white', borderRadius: 1 }}>
            {/* Administration Section */}
            <ListItem button onClick={() => setAdminExpanded(!adminExpanded)}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Administration" />
              {adminExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={adminExpanded}>
              <List component="div" disablePadding>
                <ListItem button sx={{ pl: 4 }}>
                  <ListItemText primary="Master Data" sx={{ color: '#00693C' }} />
                </ListItem>
                <ListItem button sx={{ pl: 4 }}>
                  <ListItemText primary="Invoices" sx={{ color: '#00693C' }} />
                </ListItem>
                <ListItem button sx={{ pl: 4 }}>
                  <ListItemText primary="Passwords" sx={{ color: '#00693C' }} />
                </ListItem>
                <ListItem button sx={{ pl: 4 }}>
                  <ListItemText primary="Online Cancellation" sx={{ color: '#00693C' }} />
                </ListItem>
              </List>
            </Collapse>

            {/* Legal Section */}
            <ListItem button onClick={() => setLegalExpanded(!legalExpanded)}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Legal" />
              {legalExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={legalExpanded}>
              <List component="div" disablePadding>
                <ListItem button sx={{ pl: 4 }}>
                  <ListItemText primary="Privacy Policy" sx={{ color: '#00693C' }} />
                </ListItem>
                <ListItem button sx={{ pl: 4 }}>
                  <ListItemText primary="Legal Notice" sx={{ color: '#00693C' }} />
                </ListItem>
              </List>
            </Collapse>
          </List>
        </Box>

        {/* Main Content Area - Updated for Hardware/Parts */}
        <Box sx={{ flex: 1, bgcolor: 'white', borderRadius: 1, p: 3 }}>
          <Typography variant="h6" sx={{ mb: 3 }}>PARTS OVERVIEW</Typography>
          
          <Typography paragraph>
            Hello Mohammed ibrahim Belhachemia,
          </Typography>

          <Typography paragraph>
            Below you will find an overview of the hardware parts associated with your customer number K545569. 
            By clicking on the respective table row, you can view the list of parts in your inventory. 
            By clicking on "Manage Part", you will be redirected to the detailed information of the corresponding item.
          </Typography>

          <Typography variant="h6" color="#00693C" sx={{ my: 2 }}>
            YOUR HARDWARE INVENTORY
          </Typography>

          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <TextField 
              placeholder="Search parts"
              size="small"
              sx={{ width: 300 }}
            />
            <Button 
              variant="contained" 
              sx={{ 
                bgcolor: '#00693C',
                '&:hover': { bgcolor: '#005731' }
              }}
            >
              Search
            </Button>
            
            <Button
              variant="contained"
              startIcon={<ScannerIcon />}
              sx={{ 
                bgcolor: '#00693C',
                '&:hover': { bgcolor: '#005731' },
                ml: 2
              }}
            >
              Scan
            </Button>

            <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox />
                <Typography>Show part details</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox />
                <Typography>Show actions</Typography>
              </Box>
            </Box>
          </Box>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Part ID</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Part Name</TableCell>
                <TableCell>Condition</TableCell>
                <TableCell>Stock Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Table content will be populated with hardware data */}
            </TableBody>
          </Table>

          <Button 
            variant="contained" 
            sx={{ 
              mt: 3,
              bgcolor: '#00693C',
              '&:hover': { bgcolor: '#005731' }
            }}
          >
            Add New Part
          </Button>
        </Box>
      </Container>

      {/* Add Footer at the bottom */}
      <Box sx={{ mt: 'auto' }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default Space; 